import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { LibraryComponent, LibraryComponentPayload } from 'icreate/common/models/library-component';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LibraryComponentService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getByElementComponentId(elementComponentId: string) {
        return await lastValueFrom(
            this.http.get<LibraryComponent[]>(`${this.domain}/api/component`, {
                headers: this.headers,
                params: { elementComponentId },
            })
        );
    }

    async getByShipyardId(shipyardId: string) {
        return await lastValueFrom(
            this.http.get<LibraryComponent[]>(`${this.domain}/api/component`, {
                headers: this.headers,
                params: { shipyardId },
            })
        );
    }

    async getByLibraryCategoryId(libraryCategoryId: string) {
        return await lastValueFrom(
            this.http.get<LibraryComponent[]>(`${this.domain}/api/component`, {
                headers: this.headers,
                params: { libraryCategoryId },
            })
        );
    }

    async create(componentData: LibraryComponentPayload) {
        return await lastValueFrom(
            this.http.post<LibraryComponent>(`${this.domain}/api/component`, componentData, {
                headers: this.headers,
            })
        );
    }

    async update(componentData: LibraryComponent) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/component/${componentData.id}`, componentData, {
                headers: this.headers,
            })
        );
    }

    async deleteComponent(componentId: string) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/component/${componentId}`));
    }

    async duplicateComponent(libraryComponentData: LibraryComponent) {
        return await lastValueFrom(
            this.http.post<LibraryComponent>(`${this.domain}/api/component/duplicate`, libraryComponentData, {
                headers: this.headers,
            })
        );
    }
}
